import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/components/index/Index'
import Sy from '@/components/index/Sy'
import Login from '@/components/user/Login'
import Home from '@/components/user/Home'
import Userinfo from '@/components/user/Userinfo'
import Welcome from '@/components/Welcome'
import jbhf from '@/components/user/jbhf'
import jbcx from '@/components/user/jbcx'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      redirect:'/home/jbhf', 
      component: HelloWorld,
      meta: {
          requireAuth:false      
        }
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      meta: {
          requireAuth:false      
        },
      redirect:'/Sy', 
      children: [
          { path: '/Sy', component: Sy ,meta: { requireAuth:false }},
          { path: '/login', component: Login ,meta: { requireAuth:false }},
          { path: '/home', component: Home ,meta: { requireAuth:false },
          redirect:'/home/jbhf', 
            children: [
              { path: '/home/jbhf', component: jbhf ,meta: { requireAuth:true }},
              { path: '/home/jbcx', component: jbcx ,meta: { requireAuth:true }},
            ]
         }
      ]
    }, 
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requireAuth:false      
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js